module.exports = __webpack_public_path__ + "img/1485192538.88c77089.jpg";